import React from 'react';

interface IProps {
  style?: any;
}

const WarningIcon:React.FC<IProps> = (props) => {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="12" r="8" fill="#E6D863"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 14.65V7.766h2v6.884h-2zM10 16.224v-1.048h2v1.048h-2z" fill="#122442"/>
    </svg>
  )
}
export default WarningIcon;